import { AppState } from 'store';

export const getDrawerIsOpen = (state: AppState) => state.appSettings.drawerOpen;
